
      const $loading = document.getElementById('loading');
      const hideLoading = () => { if ($loading) $loading.style.display = 'none'; };

      // Fehler global sichtbar machen
      window.addEventListener('error', e => alert('Error: ' + (e?.error?.message || e.message)));
      window.addEventListener('unhandledrejection', e => alert('Unhandled: ' + (e?.reason?.message || e.reason)));

      // Mobile-Erkennung
      function isMobileDevice() {
        try {
          if (navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean') {
            return navigator.userAgentData.mobile;
          }
        } catch {}
        const ua = (navigator.userAgent || navigator.vendor || '').toLowerCase();
        const uaMobile = /android|iphone|ipod|iemobile|blackberry/.test(ua) || (/ipad/.test(ua) && !window.MSStream);
        const coarse = matchMedia('(pointer: coarse)').matches;
        const narrow = matchMedia('(max-width: 768px)').matches;
        return uaMobile || (narrow && coarse);
      }

      const params = new URLSearchParams(location.search);
      const force = params.get('force'); // ?force=mobile | ?force=desktop
      const FALLBACK_URL = '/raute_fallback.html';

      const mobile = (force === 'mobile') || (force !== 'desktop' && isMobileDevice());

      if (mobile) {
        location.replace(FALLBACK_URL);
      } else {
        const ENTRY = '/src/main.ts'; // ggf. anpassen, falls dein Entry anders heißt
        import(ENTRY).then(() => {
          requestAnimationFrame(hideLoading);
        }).catch((e) => {
          hideLoading();
          alert('Fehler beim Import von ' + ENTRY + ':\n' + (e?.message || e));
        });
      }
    